import { render, staticRenderFns } from "./MyUnits.vue?vue&type=template&id=81f3545c"
import script from "./MyUnits.vue?vue&type=script&lang=js"
export * from "./MyUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports